import request from '@/utils/request'
// 栏目
export const getCollectionList = data => {
	return request({
		method: 'POST',
		url: '/api/getCollectionListAll',
		data
	})
}
export const getDetail = data => {
	return request({
		method: 'POST',
		url: '/api/getDetail',
		data
	})
}
export const getPaymentList = data => {
	return request({
		method: 'POST',
		url: '/api/getPaymentListAll',
		data
	})
}
export const getHExamineList = data => {
	return request({
		method: 'POST',
		url: '/api/getHExamineList',
		data
	})
}
export const exportReportHExamine = data => {
	return request({
		method: 'POST',
		url: '/api/exportReportHExamine',
		data
	})
}
export const searchSupplyPay = data => {
	return request({
		method: 'POST',
		url: '/api/searchSupplyPay',
		data
	})
}
export const syncSupplyPay = data => {
	return request({
		method: 'POST',
		url: '/api/syncSupplyPay',
		data
	})
}
export const saveSupplyPay = data => {
	return request({
		method: 'POST',
		url: '/api/saveSupplyPay',
		data
	})
}
export const saveApproval = data => {
	return request({
		method: 'POST',
		url: '/api/saveApproval',
		data
	})
}
export const getSupplyPayDataList = data => {
	return request({
		method: 'POST',
		url: '/api/getSupplyPayDataList',
		data
	})
}
// 按客商名称远程搜索结算账户（供应商账户 / 客户账户）
export const getSettlementAccountList = data => {
	return request({
		method: 'POST',
		url: '/api/getSettlementAccountList',
		data
	})
}
export const saveMobilePayment = data => {
	return request({
		method: 'POST',
		url: '/api/saveMobilePayment',
		data
	})
}
